import { createRefetchContainer, graphql } from 'react-relay';
import Invoice from './InvoiceComponent';

export default createRefetchContainer(
  Invoice,
  {
    node: graphql`
      fragment InvoiceContainer_node on Invoice {
        id
        title
        can_edit
        can_email
        share_token
        brand_logo_url
        brand_header
        recipient_first_name
        recipient_last_name
        recipient_company_name
        recipient_email
        recipient_phone
        recipient_address
        deletable
        down_payment_cents
        down_payment_currency
        down_payment_distribution_type
        down_payment_due_at
        down_payment_percent
        down_payment_status
        number
        pplan_distribution_type
        total_cents
        total_paid_cents
        accepted_payment_methods {
          edges {
            node {
              __typename
              ... on CashPaymentMethod {
                id
                enabled
                instructions
              }
              ... on CheckPaymentMethod {
                __typename
                id
                address
                enabled
                pay_to
              }
              ... on CustomPaymentMethod {
                id
                enabled
                label
                instructions
              }
              ... on SquarePaymentMethod {
                __typename
                id
                enabled
                application_id
                location_id
                location_name
              }
            }
          }
        }
        i_pplan_items {
          edges {
            node {
              amount_cents
              amount_currency
              due_at
              id
              locked
              status
            }
          }
        }
        invoice_event_segments(first: 99999)
          @connection(key: "InvoiceContainer_invoice_event_segments") {
          edges {
            node {
              id
              title
              start_at
              end_at
              time_zone
              all_day
              location
              line1
              line2
              city
              province
              postal_code
              room
              notes
            }
          }
        }
        invoice_line_items(first: 99999)
          @connection(key: "InvoiceContainer_invoice_line_items") {
          edges {
            node {
              id
              description
              position
              price_cents
              price_currency
              quantity
              title
            }
          }
        }
        payments {
          edges {
            node {
              ... on CashPayment {
                __typename
                id
                amount_cents
                amount_currency
                name
                notes
                status
                paid_at
                refunds {
                  edges {
                    node {
                      id
                      amount_cents
                      amount_currency
                      notes
                      refunded_at
                    }
                  }
                }
              }
              ... on CheckPayment {
                __typename
                id
                amount_cents
                amount_currency
                name
                notes
                status
                paid_at
                refunds {
                  edges {
                    node {
                      id
                      amount_cents
                      amount_currency
                      notes
                      refunded_at
                    }
                  }
                }
              }
              ... on CustomPayment {
                __typename
                id
                amount_cents
                amount_currency
                name
                notes
                status
                label
                paid_at
                refunds {
                  edges {
                    node {
                      id
                      amount_cents
                      amount_currency
                      notes
                      refunded_at
                    }
                  }
                }
              }
              ... on SquarePayment {
                __typename
                id
                amount_cents
                amount_currency
                name
                paid_at
                refunds {
                  edges {
                    node {
                      id
                      amount_cents
                      amount_currency
                      notes
                      refunded_at
                    }
                  }
                }
              }
            }
          }
        }
        workspaces {
          edges {
            node {
              id
              event {
                id
                ...Share_event
              }
            }
          }
        }
      }
    `,
    viewer: graphql`
    fragment InvoiceContainer_viewer on User {
      id
      first_name
      last_name
      s_time_zone
      payment_methods(first: 99999) @connection(key: "InvoiceContainer_payment_methods") {
        edges {
          node {
            ... on SquarePaymentMethod {
              __typename
              id
              enabled
              application_id
              location_id
            }
            ... on CashPaymentMethod {
              __typename
              id
              enabled
              instructions
            }
            ... on CheckPaymentMethod {
              __typename
              id
              address
              enabled
              pay_to
            }
            ... on CustomPaymentMethod {
              __typename
              id
              label
              enabled
              instructions
            }
          }
        }
      }
      ...AvailabilityCalendarContainer_viewer
      ...ScheduleContainer_viewer
      primary_brand {
        id
      }
      ...LibraryContainer_viewer
    }
    `,
  },
  graphql`
    query InvoiceContainer_RefetchQuery($id: ID!) {
      node(id: $id) {
        ...InvoiceContainer_node
      }
    }
  `
);



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/InvoiceContainer.js